import React from 'react';
import './WhatYouLearn.css';
import { CheckCircle } from 'lucide-react';

const courses = [
  "Labour Laws",
  "Accountancy",
  "PYQ Analysis: UPSC Prelims",
  "CSAT",
  "BPSC",
  "EPFO",
  "ALC/LEO",
  "ATC"
];

const WhatYouLearn = () => {
  return (
    <section className="what-you-learn-container">
      <div className="what-you-learn-wrapper">
        <h2 className="what-you-learn-heading">What You’ll Learn</h2>
        <p className="what-you-learn-subheading">
          Explore the complete set of curated courses designed to help you crack competitive exams with confidence.
        </p>

        <div className="what-you-learn-list">
          {courses.map((course, index) => (
            <div key={index} className="what-you-learn-item">
              <CheckCircle size={22} className="what-you-learn-icon" />
              <span className="what-you-learn-text">{course}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatYouLearn;
